<script>
export default
{
    name: 'mv-uploader',

    props:
    {
        multiple: {
            type: Boolean,
            default: false,
        },

        disabled: {
            type: Boolean,
            default: false,
        },

        accept: {
            type: String,
            default: '',
        },

        any: Boolean,
        type: null,
    },

    data()
    {
        return {
            uploader: null,
            jqXHR: null,
            currentFile: '',

            options: {
                url: this.any ? process.env.API_SERVER + '/attachments/upload' : process.env.API_SERVER + '/attachments/upload-image',
                maxChunkSize: 20000000,
                method: 'POST',
                sequentialUploads: true,
                formData: (form) => {
                    return [{
                        name: '_token',
                        value: document.querySelector('meta[name=csrf-token]') != null ?
                            document.querySelector('meta[name=csrf-token]').getAttribute('content') :
                            null
                    }, {
                        name: 'type',
                        value: this.type
                    }]
                },
                add: (e, data) => {
                    this.$emit('upload-start')
                    this.jqXHR = data.submit()
                },
            }
        }
    },

    mounted()
    {
        this.initFileUploader()
    },

    methods:
    {
        initFileUploader()
        {
            // FONTOS: Emlékeztető leginkább nekem, a jquery-ui -t ha használom akkor bootstrap ELŐTT kell behívni, mert nem szeretik egymást

            // Reinit, különben bugos ha simán feltöltök utána nem tudok vágólapról másolni vagy droppolni
            try {
                $(this.$refs.elem).fileupload('destroy');
                // De csak néha ...
            } catch(err) {}
            // Hát a faszom ....
            if (this.uploader != null)
            {
                this.uploader.off('fileuploaddone')
                this.uploader.off('fileuploadchunksend')
                this.uploader.off('fileuploadchunkdone')
                this.uploader.off('fileuploadchunkfail')
                this.uploader.off('fileuploadfail')
                this.uploader.off('fileuploadprogressall')
            }
            this.uploader = null

            // Na ez megvolt, akkor init ...

            this.uploader = $(this.$refs.elem).fileupload(this.options)

            this.uploader.on('fileuploaddone', (e, data) => {
                this.$emit('upload-done', data.result)
                this.initFileUploader()
            })

            this.uploader.on('fileuploadchunksend', (e, data) => {
                this.$emit('upload-chunksend', data.files[0].name)
            })
            this.uploader.on('fileuploadchunkdone', (e, data) => {
                this.$emit('upload-chunkdone')
            })

            this.uploader.on('fileuploadchunkfail', (e, data) => {
                this.$emit('upload-fail')
                // Itt nem kell reinit mert csak egy chunkot nem tudott feltölteni, mert be volt rúgva, majd újra próbálja ... vagy nem ( köszi Safari )
            })

            this.uploader.on('fileuploadfail', (e, data) => {
                this.$emit('upload-fail')
                this.$snotify.error('Sikertelen fájl feltöltés!')
                this.initFileUploader()
            })

            this.uploader.on('fileuploadprogressall', (e, data) => {
                let ret = {
                    progress: Math.floor(data.loaded / data.total * 100),
                    rate: this.getRate(data.bitrate)
                }
                this.$emit('upload-progress', ret)
            })
        },

        add(files)
        {
            this.uploader.fileupload('add', { files: files })
        },

        abort()
        {
            this.$emit('upload-done')
            if (this.jqXHR != null)
                this.jqXHR.abort()
        },

        getRate(b)
        {
            var u = 0, s=1000;
            while (b >= s || -b >= s) {
                b /= s;
                u++;
            }
            return (u ? b.toFixed(1) + ' ' : b) + ' KMGTPEZY'[u] + 'b/s';
        },
    },
}
</script>

<template>
    <span><input type="file" ref="elem" name="file" :multiple="multiple" :disabled="disabled" :accept="accept"></span>
</template>

<style scoped>
input {
    display:none;
    width: 0.1px;
    z-index: -99999999;
    opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/Uploader.vue